<template>
  <div class="file-attachment">
    <div class="flex w-full file-details">
      <div>
        <a :href="file.url" target="_blank">{{file.name}}</a>
      </div>
      <div class="ml-auto action-buttons">
        <feather-icon
          icon="EditIcon"
          svgClasses='h-5 w-5 color-current text-blue'
          class="cursor-pointer"
          @click.stop="startEditing()"
        />
        <feather-icon
          @click.stop="$emit('file-deleted', file)"
          icon="Trash2Icon"
          svgClasses="h-5 w-5 color-current text-danger"
          class="cursor-pointer ml-5"
        />
      </div>
    </div>
    <vs-prompt
      title="Edit file"
      color="primary"
      @cancel="closeFileModal"
      @accept="changeFile"
      @close="closeFileModal"
      :is-valid="validFile"
      :active.sync="editFile">
       <div class="edit-file-prompt pt-10">
          <div class="w-full grouper-field file-edition mb-5" v-if="editFile">
            <vs-input class="w-full" v-model="fileName" label="File name"></vs-input>
          </div>
          <div class="w-full">
            <label>Change content</label>
            <upload-file
              automatic
              class="w-full pl-0"
              text="Drop or click to select your file here"
              @on-success="successUpload"
              @on-error="errorUpload"
              :uploadMethod="saveFormData"
              :singleUpload="true"
            />
            <small class="pl-5">File selected: {{ fileSelected }}</small>
          </div>
          <vs-alert color="warning" icon="info" class="mt-10" v-if="fileCourses && fileCourses.length">
            You are about to change a file that is in use in more than one place.
          </vs-alert>
          <div class="file-in-courses courses-data vs-con-loading__container mt-10">
            <h5>This file is also attached to the following courses:</h5>
            <ul class="course-list ml-10 mt-5" v-if="fileCourses && fileCourses.length">
              <li class="p-2 course-list__course" v-for="course in fileCourses" :key="course.id">
                <a target="_blank" rel="noopener noreferrer" :href="`/edit/course/${course.id}`">{{ course.name }}</a>
                <span class="course-list__course-files"> ({{ filesInContent(course) }} {{ filesInContent(course) > 1 ? 'files' : 'file' }} attached)</span>
              </li>
            </ul>
            <div v-else>
              No courses were found.
            </div>
          </div>
       </div>
     </vs-prompt>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import UploadFile from "../components/UploadFile";
export default {
  components: {
    UploadFile
  },
  props: {
    file: Object,
    type: String,
    content: Object,
  },
  data: () => {
    return {
      editFile: false,
      fileName: '',
      fileCourses: null,
      coursesLoading: false,
      currentFormData: null,
    }
  },
  computed: {
    validFile() {
      return this.fileName !== ''
    },
    courseContent() {
      return this.type === 'course'
    },
    fileSelected() {
      let name = 'none'
      let value = null
      if (!this.currentFormData) return name
      for ([, value] of this.currentFormData.entries()) {
        if (value instanceof File) {
          name = value.name
          break
        } else {
          name = value
        }
      }
      return name
    }
  },
  methods: {
    ...mapActions('files', ['changeFileName', 'changeFileUrl', 'reUploadAFile']),
    ...mapActions('courses', ['searchCourses']),
    async changeFile() {
      try {
        this.editFile = false
        this.$vs.loading()
        let changed = false
        if (this.fileName !== this.file.name) {
          await this.changeFileName({
            name: this.fileName,
            file: this.file
          })
          this.$emit('file-changed', {
            name: this.fileName,
            file: this.file
          })
          changed = true
        }
        if (this.currentFormData) {
          await this.reUploadFileWrapper(this.currentFormData)
          this.currentFormData = null
          changed = true
        }
        await this.$nextTick()
        this.$vs.loading.close()
        if (changed) {
          this.$vs.notify({
            color: "success",
            title: "Change file Success",
            text: "The file was changed successfully"
          });
        }
      } catch (error) {
        this.showError(error)
        this.$vs.loading.close()
      }
    },
    startEditing() {
      this.fileName = this.file.name
      this.editFile = true
      this.getCoursesOfFiles()
    },
    closeFileModal() {
      this.editFile = false
      this.currentFormData = null
    },
    async getCoursesOfFiles() {
      await this.$nextTick()
      if (this.file.metadata.courses && this.file.metadata.courses.length) {
        this.$vs.loading({
          container: '.courses-data',
          scale: 0.6
        })
        const otherCourses = this.file.metadata.courses.filter(c => c.id !== this.content.id)
        if (otherCourses && otherCourses.length) {
          const response = await this.searchCourses({
            ids: otherCourses.map(c => c.id)
          })
          this.fileCourses = response.results
        }
        await this.$nextTick()
        this.$vs.loading.close('.courses-data > .con-vs-loading')
      }
    },
    errorUpload(error) {
      this.showError(error)
    },
    successUpload() {
    },
    saveFormData(formData) {
      this.currentFormData = formData
      return Promise.resolve(true)
    },
    async reUploadFileWrapper(formData) {
      try {
        const response = await this.reUploadAFile({ formData, fileId: this.file.id} )
        this.$emit('file-changed', {
          name: response.name,
          file: this.file
        })
      } catch(error) {
        this.showError(error)
      }
    },
    filesInContent(content) {
      if (this.courseContent) {
        return content.files_uuids.length
      } else {
        return content.files.length
      }
    },
  },
  mounted() {
    if (this.editFile) this.getCoursesOfFiles()
  }
}
</script>
<style lang="scss" scoped>
.edit-file-prompt {
  .course-list {
    list-style-type: square;
    &__course-files {
      color: #cccccc;
    }
  }
}
</style>